import { ref as databaseRef, set as databaseSet } from 'firebase/database';
import { useObjectVal } from 'react-firebase-hooks/database';

import { selectAuth } from '@/features/auth';
import { useAppSelector } from '@/hooks';
import { getFirebaseDatabase } from '@/providers/firebase';

import type { OptOutStatus } from '../types/opt-out';

export function useOptOutStatus(): [
  OptOutStatus | null,
  (value: OptOutStatus) => Promise<void>,
] {
  const auth = useAppSelector(selectAuth);
  const optOutRef = databaseRef(
    getFirebaseDatabase(),
    `${auth.user?.uid}/optOutStatus`,
  );

  const [optOutValue, loading] = useObjectVal<OptOutStatus>(optOutRef);

  const setOptOutStatus = async (value: OptOutStatus): Promise<void> => {
    if (auth.user === null) return;
    await databaseSet(optOutRef, value);
  };

  const transformedValue = loading ? null : optOutValue ?? null;

  return [transformedValue, setOptOutStatus];
}
